<template>
  <div class="v3_box_teal">
    <div class="v3_box_teal_header shadow-none">
      <b-row align-v="center">
        <b-col cols="6" class="d-flex align-items-center v3_color_teal">
          <h2 class="mb-0 font_Montserrat font_size_1250rem text-uppercase letter_spacing_20">
            <strong>Connect</strong>
          </h2>
        </b-col>
        <b-col cols="6" class="d-flex justify-content-end my-2 my-lg-0">
          <slot name="action-buttons" />
          <b-button
            class="v3_button_collapse text-decoration-none"
            v-b-toggle="'connect-section'"
            variant="link"
          >
            <span class="when-closed when">
              <span class="bv-d-sm-down-none">Expand</span>
              <i class="mdi mdi-chevron-down" />
            </span>
            <span class="when-opened when">
              <span class="bv-d-sm-down-none">Collapse</span>
              <i class="mdi mdi-chevron-up" />
            </span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-collapse
      id="connect-section"
      visible
      class="v3_box_teal_body p-4"
    >
      <slot />
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'ConnectSection',
};
</script>

<style scoped></style>
